import { render, staticRenderFns } from "./ReferenceNumberForm.vue?vue&type=template&id=4c0de6a0&scoped=true&"
import script from "./ReferenceNumberForm.vue?vue&type=script&lang=js&"
export * from "./ReferenceNumberForm.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceNumberForm.vue?vue&type=style&index=0&id=4c0de6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0de6a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
